export default __webpack_public_path__ + "static/media/bootstrap-logo.d2164ef4.svg";